// extracted by mini-css-extract-plugin
export default {"tooltip":"ZsWSi","tooltip-container":"n7_IR","tooltip-open":"q9tId","tooltip-trigger":"ubiBk","tooltip-delete":"iajOu"};